import { getIsMemberAreaInstalled } from '../store/communities-context/communities-context-selectors';
import {
  getSocialSharingProviders,
  getIsCommentsEnabled,
} from '../selectors/app-settings-selectors';

const createPermissionFlags = (state) => ({
  isMemberAreaInstalled: getIsMemberAreaInstalled(state),
  isSocialSharingEnabled: Boolean(getSocialSharingProviders(state).length),
  isCommentsEnabled: getIsCommentsEnabled(state),
});

export default createPermissionFlags;
